import { ModernNotification, Notification } from '../types';

/**
 * The backend `Notification` schema has no discriminator field between the legacy
 * and modern shapes, so the modern one is detected structurally: only it carries `text`.
 */
export const isModernNotification = (notification: Notification): notification is ModernNotification =>
    typeof (notification as ModernNotification).text === 'string';
